/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const Color = require('../types/Color')
const StyleTrait = require('../types/StyleTrait')
const CPolygone = require('./CPolygone')
const CSurface = require('./CSurface')
module.exports = CSurfacePolygone

/**
 * Classe repésentant une surface intérieure à un polygone.
 * Le polygone ne doit pas de préférence être croisé.
 * @constructor
 * @extends CSurface
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
 * @param {Boolean} estElementFinal : true si élément final de construction.
 * @param {Color} couleur : La couleur.
 * @param {Boolean} masque : true si l'objet est masqué.
 * @param {mtg32.StyleRemplissage} styleRemplissage : Entier donnant le style de remplissage.
 * @param {CPolygone} bord : Le polygone qui borde la surface.
 * @returns {CSurfacePolygone}
 */
function CSurfacePolygone (listeProprietaire, impProto, estElementFinal, couleur,masque, styleRemplissage, bord) {
  if (arguments.length === 1) CSurface.call(this, listeProprietaire);
  else {
    CSurface.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord);
    this.polygone = new CPolygone(null, null, false, new Color(0,0,0), true, StyleTrait.traitFin, bord.colPoints);
  }
}
CSurfacePolygone.prototype = new CSurface();
CSurfacePolygone.prototype.constructor = CSurfacePolygone;
CSurfacePolygone.prototype.superClass = "CSurface";
CSurfacePolygone.prototype.className = "CSurfacePolygone";

CSurfacePolygone.prototype.getClone = function(listeSource, listeCible) {
  var ind1 = listeSource.indexOf(this.bord);
  var ind2 = listeSource.indexOf(this.impProto);
  return new CSurfacePolygone(listeCible, listeCible.get(ind2, "CImplementationProto"),
    this.estElementFinal, this.couleur, this.masque, this.styleRemplissage, listeCible.get(ind1, "CPolygone"));
};
CSurfacePolygone.prototype.ajouteAntecedents = function(liste) {
  liste.add(this.bord);
};
CSurfacePolygone.prototype.positionne = function(infoRandom, dimfen) {
  CSurface.prototype.positionne.call(this, infoRandom, dimfen);
  this.polygone.setClone(this.bord);
};
CSurfacePolygone.prototype.setClone = function(ptel) {
  CSurface.prototype.setClone.call(this, ptel);
  this.polygone.setClone(ptel.polygone);
};
/**
 * Fonction renvoyant une chaîne de caractères utilisée dans le svg élément
 * représentant la surface.
 * @returns {String}
 */
CSurfacePolygone.prototype.creePoints = function() {
  var i, points = "";
  // Pour un polygone, le dernier point est le même que le premier mais pas pour svg
  for (i = 0; i < this.polygone.nombrePoints - 1; i ++) {
    points += this.polygone.abscissesCoordonneesPoints[i] + "," + this.polygone.ordonneesCoordonneesPoints[i] + " ";
  }
  return points;
};
CSurfacePolygone.prototype.read = function(inps, list){
  CSurface.prototype.read.call(this, inps, list);
    this.polygone = new CPolygone(null, null, false, new Color(0,0,0), true,
      new StyleTrait(list, StyleTrait.styleTraitContinu, 1), this.bord.colPoints);
};



// WEBPACK FOOTER //
// ./src/objets/CSurfacePolygone.js